import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

const RedirectToEmployeesPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()

  const to = navigation.settings.locations.locationsId.employees.fullPath({ id })

  return <Navigate to={to} />
}

export default RedirectToEmployeesPage
